import { errorMessage } from "actions/message";
import { get, post, put } from "utils/api";
import { browserHistory } from "browser-history";

export const Types = {
  SYNTHPOP_CALL_LOG_METRICS_REQUEST: "SYNTHPOP_CALL_LOG_METRICS_REQUEST",
  SYNTHPOP_CALL_LOG_METRICS_SUCCESS: "SYNTHPOP_CALL_LOG_METRICS_SUCCESS",
  SYNTHPOP_CALL_LOG_METRICS_FAILURE: "SYNTHPOP_CALL_LOG_METRICS_FAILURE",
  SYNTHPOP_CALL_LOGS_REQUEST: "SYNTHPOP_CALL_LOGS_REQUEST",
  SYNTHPOP_CALL_LOGS_SUCCESS: "SYNTHPOP_CALL_LOGS_SUCCESS",
  SYNTHPOP_CALL_LOGS_FAILURE: "SYNTHPOP_CALL_LOGS_FAILURE",
  SYNTHPOP_PENDING_SUMMARY_REQUEST: "SYNTHPOP_PENDING_SUMMARY_REQUEST",
  SYNTHPOP_PENDING_SUMMARY_SUCCESS: "SYNTHPOP_PENDING_SUMMARY_SUCCESS",
  SYNTHPOP_PENDING_SUMMARY_FAILURE: "SYNTHPOP_PENDING_SUMMARY_FAILURE",
  SYNTHPOP_PATIENT_PENDING_REQUEST: "SYNTHPOP_PATIENT_PENDING_REQUEST",
  SYNTHPOP_PATIENT_PENDING_SUCCESS: "SYNTHPOP_PATIENT_PENDING_SUCCESS",
  SYNTHPOP_PATIENT_PENDING_FAILURE: "SYNTHPOP_PATIENT_PENDING_FAILURE",
  SYNTHPOP_PATIENT_PENDING_CLEAR: "SYNTHPOP_PATIENT_PENDING_CLEAR"
};

export const fetchSynthpopCallLogMetrics = (startDate, endDate, companyGuid) => async dispatch => {
  dispatch({ type: Types.SYNTHPOP_CALL_LOG_METRICS_REQUEST });
  try {
    const response = await post("synthpop/call-logs/metrics", {
      startDate,
      endDate,
      companyGuid: companyGuid || null
    });
    dispatch({ type: Types.SYNTHPOP_CALL_LOG_METRICS_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.SYNTHPOP_CALL_LOG_METRICS_FAILURE });
    dispatch(errorMessage("Failed to fetch AI call metrics"));
  }
};

export const fetchSynthpopCallLogs = (params) => async dispatch => {
  dispatch({ type: Types.SYNTHPOP_CALL_LOGS_REQUEST });
  try {
    const response = await post("synthpop/call-logs", params);
    dispatch({ type: Types.SYNTHPOP_CALL_LOGS_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.SYNTHPOP_CALL_LOGS_FAILURE });
    dispatch(errorMessage("Failed to fetch AI call logs"));
  }
};

export const exportSynthpopCallLogs = (params) => async dispatch => {
  try {
    await put("synthpop/call-logs/export", params);
    browserHistory.push("/exports");
  } catch (error) {
    dispatch(errorMessage("Failed to export AI call logs"));
  }
};

export const fetchSynthpopPendingSummary = ({ startDate, endDate }) => async dispatch => {
  dispatch({ type: Types.SYNTHPOP_PENDING_SUMMARY_REQUEST });
  try {
    const response = await post("synthpop/call-logs/pending", { startDate, endDate });
    dispatch({ type: Types.SYNTHPOP_PENDING_SUMMARY_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.SYNTHPOP_PENDING_SUMMARY_FAILURE });
    dispatch(errorMessage("Failed to fetch pending AI call summary"));
  }
};

export const fetchPatientPendingStatus = (patientGuid) => async dispatch => {
  dispatch({ type: Types.SYNTHPOP_PATIENT_PENDING_REQUEST });
  try {
    const response = await get(`synthpop/call-logs/pending/${patientGuid}`);
    dispatch({ type: Types.SYNTHPOP_PATIENT_PENDING_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: Types.SYNTHPOP_PATIENT_PENDING_FAILURE });
    dispatch(errorMessage("Failed to look up patient pending status"));
  }
};

export const clearPatientPendingStatus = () => ({ type: Types.SYNTHPOP_PATIENT_PENDING_CLEAR });
